import { GtmEvents } from '@/gtm/gtm-events';
import cleanObject from '@/utils/helpers/cleanObject';

export class CommonGtmEvents extends GtmEvents {
  eventCategory = 'СобытияОбщие';

  addToFavorite({
    productCode, productId, price, quantity, path,
  }) {
    return this.gtmEvent({
      eventAction: 'Общее_ДобавитьВИзбранное',
      eventLabel: productCode,
      params: {
        mindbox: {
          sku: productId,
          price,
          quantity: quantity || 1,
          path,
        },
      },
    });
  }

  removeFromFavorite({ productCode, path }) {
    return this.gtmEvent({
      eventAction: 'Общее_УдалитьИзИзбранного',
      eventLabel: JSON.stringify({ productId: productCode, path }),
    });
  }

  toggleFavorite({
    value, productCode, productId, price, quantity, path,
  }) {
    return value
      ? this.addToFavorite({
        productCode, productId, price, quantity, path,
      })
      : this.removeFromFavorite({ productCode, path });
  }

  addToCart(gtmData) {
    return this.gtmEvent({
      eventAction: 'Общее_ДобавитьВКорзину',
      eventLabel: JSON.stringify(gtmData),
    });
  }

  sendUserAccount(city, {
    // TODO: { id, ...rest }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    birthday, email, gender, firstName, id, phone,
  }, { ip }) {
    const userAuthType = id ? '3' : '1'; // 3 - авторизован, 1 - не авторизован

    return this.gtmEvent({
      event: '',
      params: {
        userParams: cleanObject({
          ip,
          userId: id,
          userAuthType,
        }),
      },
    });
  }

  successSubscribe({ url, email }) {
    return this.gtmEvent({
      eventAction: 'Общее_УспешнаяПодписка',
      eventLabel: url,
      params: {
        data: {
          email,
        },
      },
    });
  }

  viewThanksPage({
    orderNumber,
    cartId,
    subtotal,
    deliveryAmount,
    products = [],
    coupons,
    accountId,
  }) {
    const coupon = products?.[0]?.discounts?.find((d) => d.type === 'promocode')?.name
      || coupons?.[0]
      || '';

    const productsData = products?.map((p) => {
      const breadcrumbs = p.models?.[0]?.breadcrumbs || [];

      return {
        name: p.models?.[0]?.name,
        id: p.id,
        price: p.totalPrice,
        category: breadcrumbs[breadcrumbs.length - 1]?.name || '',
        variant: p.skuId,
        quantity: p.quantity,
        scId: p.id,
        dimension11: p.skuId,
      };
    });

    const params = {
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            affiliation: cartId,
            id: orderNumber,
            revenue: subtotal,
            shipping: deliveryAmount,
            coupon,
          },
          products: productsData,
        },
      },
      mindbox: {
        profileid: accountId,
      },
    };

    const gtmPromise = this.gtmEvent({
      eventAction: 'СпасибоЗаЗаказ_ПросмотрСтраницы',
      eventLabel: orderNumber,
      params,
    });

    const crtoPromise = this.crtoEvent('crto_transactionpage', {
      transactionid: orderNumber,
      products: products?.map(({ id, totalPrice, quantity }) => ({
        id,
        quantity,
        price: totalPrice,
      })),
    });

    return Promise.allSettled([gtmPromise, crtoPromise]);
  }

  viewThanksPageAll({ orders, cartId, accountId }) {
    const promises = orders.map(({
      subtotal,
      deliveryAmount,
      products,
      orderNumber,
      coupons,
    }) => this.viewThanksPage({
      cartId,
      orderNumber,
      subtotal,
      deliveryAmount,
      products,
      coupons,
      accountId,
    }));

    return Promise.allSettled(promises);
  }

  clickOnSearchIcon(pageUrl) {
    return this.gtmEvent({
      eventAction: 'Поиск_Клик',
      eventLabel: JSON.stringify({ Страница: pageUrl }),
    });
  }

  playYoutubeVideo(video) {
    return this.gtmEvent({
      eventAction: 'ВидеоКлик',
      eventLabel: JSON.stringify(video),
    });
  }
}

export const commonGtmEvents = new CommonGtmEvents();
